/** @type {import('tailwindcss').Config} */
import colors from 'tailwindcss/colors.js';
delete colors['lightBlue'];
delete colors['warmGray'];
delete colors['trueGray'];
delete colors['coolGray'];
delete colors['blueGray'];

import theme from 'tailwindcss/defaultTheme.js';

export default {
	content: [
		"./js/**/*.{js,jsx,ts,tsx}",
		"./app/**/*.php",
		"./src/**/*.php",
		"./public/**/*.html",
		"./templates/**/*"
	],
	theme: {
		colors: {
			...colors,
			blackAlmost: '#333339',
			yello: {
				100: '#fff6bf',
				300: '#FEDE06',
				500: '#514721',
			},
			blu: {
				200: '#1797d9',
				300: '#2b5375',
				400: '#242c54',
			},
			facebook: {
				200: '#4c70ba',
				300: '#3b5998',
				400: '#2b406e',
			},
			grey: {
				100: "#f5f5f5",
				300: "#e5eae9",
				400: "#cdcfcd",
				500: "#6A6A6A",
			},
			primary: {
				200: '#0002FF',
				500: '#000273'
			},
			secondary: {
				300: "#DE75CC",
				500: "#BE55AC",
			},
			'admin-links': "#000273",
			'admin-menu': "#0002FF",
			'admin-menu-bg': "#000273",
			'admin-menu-hr': "#0002FF",
			'primary-admin': {
				200: '#eeb5ec',
				400: '#BE55AC',
			},
		},
		fontFamily: {
			...theme.fontFamily,

			arial: 'Arial, Helvetica, sans-serif',
			century: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
			futura: '"Futura LT", Futura, "Trebuchet MS", Arial, Helvetica, sans-serif',
			helvetica: '"Helvetica Neue", Arial, Helvetica, sans-serif',
			helveticaLight: '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Arial, Helvetica, sans-serif',
			geneva: 'Geneva, Tahoma, Verdana, sans-serif',
			georgia: 'Georgia, Palatino, "Palatino Linotype", "Times New Roman", serif',
			goudy: '"Goudy Old Style", Georgia, "Times New Roman", serif',
			palatino: 'Palatino, "Palatino Linotype", Georgia, Times, "Times New Roman", serif',
			tahoma: 'Tahoma, Geneva, Verdana, sans-serif',
			times: 'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif',
			verdana: 'Verdana, Geneva, Tahoma, sans-serif',
			mono: ['ui-monospace', 'Menlo', 'Consolas', 'monospace'],
		},
		screens: {
			...theme.screens,
			sm: '480px',
			xl: '1440px',
			xxl: '1441px',
			'2xl': '1920px',
			'3xl': '1920px'
		},
		extend: {
			scale: {
				'33': '0.3333',
				'25': '0.25',
				'200': '2.0',
			},
			spacing: {
				'128': '32rem',
			},
			zIndex: {
				'60': '60',
				'70': '70',
				'80': '80',
				'90': '90',
				'100': '100',
			}
		},
		borderRadius: {
			...theme.borderRadius,
			'sm': '0.1875rem',
		}
	},
}
